import styled from "styled-components";
import { Divider } from "antd";

export const layout = {
  labelCol: { span: 12 },
  wrapperCol: { span: 12 },
};

export const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  // Para garantir que o layout seja responsivo
  @media (max-width: 768px) {
    flex-direction: column; /* Empilhamento vertical em telas menores */
  }

  & > :first-child {
    flex: 0 0 10%; /* 10% para o topo */
  }

  & > :last-child {
    flex: 1; /* 90% para o conteúdo restante */
  }
`;
export const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;

export const ContainerModal = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ItemTextModal = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #4a4a4a;
`;

export const TextModal = styled.p`
  font-size: 16px;
  color: #6d6d6d;
  font-weight: 500;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  color: #333;
  margin-bottom: 10px;
`;

export const DividerStyled = styled(Divider)`
  margin: 8px 0;
  background-color: #e0e0e0;
`;
